import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import "./seleccionarempresa.css";

function Seleccionarempresa({ onEmpresaSelect }) {
  const [empreses, setEmpreses] = useState([]);
  const [filteredEmpreses, setFilteredEmpreses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Camp de cerca
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Configuració d'ordenació

  useEffect(() => {
    const fetchEmpreses = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/Empreses.php`);
        const data = await response.json();
        setEmpreses(data.success ? data.empreses || [] : []);
        console.log("Empreses carregades:", data);
        setFilteredEmpreses(data.success ? data.empreses || [] : []); // Inicialment totes les empreses es mostren
        console.log("Empreses després de setEmpreses:", empreses);
      } catch (error) {
        console.error("Error carregant empreses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpreses();
  }, []);

  const handleEmpresaClick = (empresa) => {
    if (onEmpresaSelect) {
      onEmpresaSelect(empresa);
    } else {
      console.error("onEmpresaSelect no està definit.");
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    // Filtra les empreses pel camp desitjat
    const filtered = empreses.filter(
      (empresa) =>
        empresa.Nom.toLowerCase().includes(value) ||
        empresa.NomComercial.toLowerCase().includes(value) ||
        empresa.CIF_DNI.toLowerCase().includes(value)
    );
    setFilteredEmpreses(filtered);
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });

    const sorted = [...filteredEmpreses].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredEmpreses(sorted);
  };

  return (
    <div>
      {/* Camp de cerca */}
      <input
        type="text"
        placeholder="Cerca per nom, CIF, etc."
        value={searchTerm}
        onChange={handleSearchChange}
        className="Dashboard-search-bar"
      />

      {/* Taula d'empreses */}
      {loading ? (
        <p>Carregant empreses...</p>
      ) : filteredEmpreses?.length > 0 ? (
        <table className="Dashboard-table">
          <thead>
            <tr>
              <th onClick={() => handleSort("Nom")}>Nom</th>
              <th onClick={() => handleSort("NomComercial")}>Nom Comercial</th>
              <th onClick={() => handleSort("CIF_DNI")}>CIF</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmpreses.map((empresa, index) => (
              <tr
                key={empresa.IdEmpresa}
                className={index % 2 === 0 ? "even-row" : "odd-row"}
                onClick={() => handleEmpresaClick(empresa)}
                style={{ cursor: "pointer" }}
              >
                <td>{empresa.Nom}</td>
                <td>{empresa.NomComercial}</td>
                <td>{empresa.CIF_DNI}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No s'ha trobat cap empresa.</p>
      )}
    </div>
  );
}

export default Seleccionarempresa;
